import Card from 'components/Card';
import CardHistory from 'components/CardHistory';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@smiles/voebiz-ui-kit';
import { useNavigate } from 'react-router-dom';
import { useMemberExtract } from '../../contexts/MemberExtract';

function Extract() {
  const { t } = useTranslation('glossary');
  const { isExtractPage, loading } = useMemberExtract();
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };

  if (isExtractPage && !loading)
    return (
      <div className="corporate-club-extract__container">
        <h2 className="corporate-club-extract__title">{t('mainTitle')}</h2>
        <p className="corporate-club-extract__subtitle">{t('mainSubtitle')}</p>
        <Card />
        <CardHistory />
        <Button onClick={handleGoBack} data-testid="Voltar" className="button-back-beneficiarie">
          Voltar
        </Button>
      </div>
    );

  return null;
}

export default Extract;
